module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-47.d4bb1ec1.jpg";